import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { installTooltips } from './tips';
/*
 * Plus Jakarta Sans, served from our own origin — plan §4.1.
 *
 * index.html used to pull four weights from fonts.googleapis.com through a
 * render-blocking stylesheet: two extra origins, two DNS+TLS handshakes, and a
 * third party in front of the first paint of every screen. Self-hosted, Vite
 * fingerprints the woff2 and Workers Static Assets edge-caches them like
 * everything else — and the CSP no longer has to name a font CDN.
 *
 * Latin subset only, and only the four weights `theme.css` actually uses.
 * Non-latin glyphs fall back to system-ui, which is what they did before.
 */
import '@fontsource/plus-jakarta-sans/latin-400.css';
import '@fontsource/plus-jakarta-sans/latin-500.css';
import '@fontsource/plus-jakarta-sans/latin-600.css';
import '@fontsource/plus-jakarta-sans/latin-700.css';
import './theme.css';
import './workspace.css';

const root = document.getElementById('root');
if (!root) throw new Error('#root is missing from index.html');

// Outside React on purpose: the bubble is owned by the document so that no
// component has to render it and no scroll container can clip it (see tips.ts).
installTooltips();

createRoot(root).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
